import React, { FC, useMemo } from "react";
import Head from "next/head";
import { decode } from "html-entities";
import Microdata from "common/Microdata/Microdata";
import { useStore } from "store";
import Static from "./Static";

export type RequiredMeta = Partial<Entity.Meta> &
  Pick<Entity.Meta, "title" | "description">;

type Props = {
  meta: RequiredMeta;
  traceId?: string;
  noIndex?: boolean;
  removeRegionFromCanonical?: boolean;
};

const emptyMeta = {
  title: "",
  h1: "",
  description: "",
  metadata: [],
  breadcrumbs: [],
  microdata: "",
};

const Meta: FC<Props> = ({
  meta = emptyMeta,
  traceId,
  noIndex,
  removeRegionFromCanonical,
}: Props) => {
  const store = useStore();
  const drawNoIndex = useMemo(() => {
    return (
      noIndex &&
      !meta.metadata.some(item => item.content === "noindex,nofollow,noarchive")
    );
  }, [meta.metadata, noIndex]);

  /* For support H1 in analytics @see YandexMetricaApiService, todo: remove */
  store.meta.set({ ...emptyMeta, ...meta });

  return (
    <>
      <Static removeRegionFromCanonical={removeRegionFromCanonical} />
      <Head>
        <title>{decode(meta.title)}</title>
        <meta name="description" content={meta.description} />
        {traceId && <meta name="uber-trace-id" content={traceId} />}
        {drawNoIndex && (
          <meta name="robots" content="noindex,nofollow,noarchive" />
        )}

        {meta.metadata?.map(metaInfo => (
          <meta
            key={metaInfo.name}
            name={metaInfo.name}
            content={metaInfo.content}
          />
        ))}
      </Head>
      {meta.microdata && <Microdata microdata={meta.microdata} />}
    </>
  );
};

export default Meta;
